var app = angular.module('app');
app.controller('appCtrl', [
    "$scope",
    "$firebaseAuth",
    "$firebaseArray",
    function($scope, $firebaseAuth, $firebaseArray) {
        $scope.title = 'Guilds';
        $scope.authObj = $firebaseAuth();
        $scope.authObj.$onAuthStateChanged(function(firebaseUser) {
            if (firebaseUser) firebaseUser.getIdTokenResult().then(function(idTokenResult) {
                $scope.$apply(function() {
                    $scope.isAuthenticated = true;
                    $scope.isAdmin = !!idTokenResult.claims.admin;
                });
            });
            else window.location.href = '/login/login';
        }, function(error) {
            console.error("Authentication state error:", error);
        });
        var ref = firebase.database().ref();
        $scope.remoteItems = $firebaseArray(ref.child("guild"));
        $scope.DB = [];
        $scope.remoteItems.$loaded().then(function() {
            angular.forEach($scope.remoteItems, function(item) {
                var newItem = new Object();
                newItem.$id = item.$id;
                newItem.name = item.name;
                newItem.points = item.points;
                $scope.DB.push(newItem);
            });
        });
        $scope.add = function() {
            window.location.href = '/guild/add';
        };
        $scope.edit = function(value) {
            window.location.href = '/guild/edit?id=' + value.$id;
        };
        $scope.delete = function(item) {
            if (confirm('Would you like to delete ' + item.name + ' now?')) {
                var record = $scope.remoteItems.$getRecord(item.$id);
                $scope.remoteItems.$remove(record).then(function() {
                    var index = $scope.DB.indexOf(item);
                    if (index > -1) $scope.DB.splice(index, 1);
                });
            }
        };
    }
]);

//# sourceMappingURL=list.aa9ce1b5.js.map
